import React, { forwardRef, Fragment, useCallback, useState } from "react";

import {
    Box,
    CardContent,
    Chip,
    Popper,
    Stack,
    Typography,
} from "@mui/material";

import { useSelector } from "react-redux";

import * as Styled from "./SourcePopover.styled";
import { SourcePopoverProps } from "./SourcePopover.types";

const popperModifiers = [
    { name: "offset", options: { offset: [0, 8] } },

    { name: "flip", enabled: false },
    {
        name: "matchAnchorWidth",
        enabled: true,
        phase: "beforeWrite" as const,
        requires: ["computeStyles"],
        fn: ({ state }: { state: any }) => {
            state.styles.popper.width = `${state.rects.reference.width}px`;
        },
        effect: ({ state }: { state: any }) => {
            state.elements.popper.style.width = `${state.elements.reference.offsetWidth}px`;
        },
    },
];

const SourcePopover = forwardRef(
    (
        {
            visible,
            sourceName,
            sourceIcon,
            pages,
            name,
            forms,
            pagesLabel = "Pages",
            formsLabel = "Forms",
        }: SourcePopoverProps,
        ref,
    ) => {
        const language = useSelector(
            (state: any) => state.languagesState.languages,
        );
        const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
        const captureAnchor = useCallback((node: HTMLSpanElement | null) => {
            setAnchorEl(node?.parentElement ?? null);
        }, []);

        return (
            <Fragment>
                <Styled.SourcePopoverAnchor ref={captureAnchor} />
                <Popper
                    open={Boolean(visible && anchorEl)}
                    anchorEl={anchorEl}
                    placement="bottom-start"
                    modifiers={popperModifiers}
                    sx={{ zIndex: (theme) => theme.zIndex.modal - 1 }}
                >
                    <Box className="tracker-detail-area">
                        <Styled.SourcePopoverContainer
                            className={`dashboard-tree-source-item no-effect dashboard-tree-source-item-1 lead-item`}
                            style={{
                                boxShadow: "none",
                                border: "1px solid #E7E7E7",
                                borderRadius: "10px",
                            }}
                        >
                            <CardContent
                                style={{ padding: "20px" }}
                                className="d-flex items-center justify-start"
                            >
                                <Typography className="mr-3">
                                    <div className="item-icon-area">
                                        <img
                                            src={sourceIcon}
                                            alt=""
                                            className="lead-connection-icon"
                                        />
                                    </div>
                                </Typography>
                                <Typography
                                    sx={{
                                        fontSize: 18,
                                        fontWeight: "700",
                                        fontFamily: "Nunito, sans-serif",
                                        color: "black",
                                    }}
                                >
                                    {sourceName}
                                </Typography>
                            </CardContent>
                            <CardContent
                                style={{ padding: "25px 20px", paddingTop: 0 }}
                                className="d-flex items-center justify-start"
                            >
                                <Box className="lead-service-info-area">
                                    <>
                                        {name && (
                                            <span
                                                style={{
                                                    display: "block",
                                                    fontSize: "14px",
                                                    color: "black",
                                                    fontWeight: "500",
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        display: "block",
                                                        fontSize: "12px",
                                                        color: "#ABABAB",
                                                        fontWeight: "400",
                                                    }}
                                                >
                                                    {language?.connections
                                                        ?.name ?? "Name"}
                                                </span>
                                                <span>{name}</span>
                                            </span>
                                        )}
                                        {/** XXXXX */}
                                        {!!pages?.length && (
                                            <div
                                                style={{
                                                    display: "block",
                                                    fontSize: "14px",
                                                    color: "black",
                                                    fontWeight: "500",
                                                    width: "100%",
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        display: "block",
                                                        fontSize: "12px",
                                                        color: "#ABABAB",
                                                        fontWeight: "400",
                                                        marginBottom: "4px",
                                                    }}
                                                >
                                                    {language?.connections
                                                        ?.pages ?? pagesLabel}
                                                </span>

                                                <Stack
                                                    gap={1}
                                                    direction="row"
                                                    flexWrap="wrap"
                                                >
                                                    {pages?.map((form) => (
                                                        <Chip
                                                            className="chip-leads-page"
                                                            label={form}
                                                            style={{
                                                                width: "fit-content",
                                                            }}
                                                            onClick={() => {}}
                                                        />
                                                    ))}
                                                </Stack>
                                            </div>
                                        )}
                                        {!!forms?.length &&
                                            forms?.every((form) => form) && (
                                                <div
                                                    style={{
                                                        display: "block",
                                                        fontSize: "14px",
                                                        color: "black",
                                                        fontWeight: "500",
                                                        width: "100%",
                                                    }}
                                                >
                                                    <span
                                                        style={{
                                                            display: "block",
                                                            fontSize: "12px",
                                                            color: "#ABABAB",
                                                            fontWeight: "400",
                                                            marginBottom: "4px",
                                                        }}
                                                    >
                                                        {language?.connections
                                                            ?.forms ??
                                                            formsLabel}
                                                    </span>
                                                    <Stack
                                                        gap={1}
                                                        direction="row"
                                                        flexWrap="wrap"
                                                    >
                                                        {forms?.map((form) => (
                                                            <Chip
                                                                className="chip-leads-page"
                                                                label={form}
                                                                style={{
                                                                    width: "fit-content",
                                                                }}
                                                                onClick={() => {}}
                                                            />
                                                        ))}
                                                    </Stack>
                                                </div>
                                            )}
                                    </>
                                </Box>
                            </CardContent>
                        </Styled.SourcePopoverContainer>
                    </Box>
                </Popper>
            </Fragment>
        );
    },
);

export default SourcePopover;
